import React, { useState } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../../styles.module.scss'
import CardTitle from '../../common/CardTitle'
import { useTranslation } from 'react-i18next'
import FilterTabs from 'srcReact/components/common2/FilterTabs'
import MembersActivity from './MembersActivity'
import MixrsActivity from './MixrsActivity'
import GroupsActivity from './GroupsActivity'
import EngagementActivity from './EngagementActivity'
import SectionTitle from '../../common/SectionTitle'

function Activity({ type, data, objectId, loading, selectedDuration }) {
  const { t } = useTranslation()
  const [scope, setScope] = useState('engagements')

  const changeScope = (newScope) => {
    setScope(newScope)
  }

  return (
    <div className={styles.activityWrapper}>
      <SectionTitle title={t('dashboard.activity.title')} />
      <div className={`${styles.card} ${parentStyles.card} `}>
        <div className={styles.activity}>
          <FilterTabs
            className={styles.filtersContainer}
            tabs={[
              {
                display: t('global.engagement', { count: 0 }),
                show: true,
                selected: scope === 'engagements',
                onClick: () => changeScope('engagements')
              },
              {
                ...(type === 'workplace'
                  ? {
                      display: t('dashboard.activity.groups'),
                      selected: scope === 'groups',
                      show: true,
                      onClick: () => changeScope('groups')
                    }
                  : {})
              },
              {
                display: t('dashboard.activity.mixrs'),
                selected: scope === 'mixrs',
                show: true,
                onClick: () => changeScope('mixrs')
              },
              {
                display: t('global.members'),
                selected: scope === 'members',
                show: true,
                onClick: () => changeScope('members')
              }
            ]}
          />
          {scope === 'members' ? (
            <MembersActivity
              type={type}
              memberActivityData={data?.Members}
              objectId={objectId}
              duration={selectedDuration}
              loading={loading}
            />
          ) : scope === 'groups' ? (
            <GroupsActivity
              groupsActivityData={data?.Groups}
              objectId={objectId}
              duration={selectedDuration}
              loading={loading}
            />
          ) : scope === 'mixrs' ? (
            <MixrsActivity
              mixrsActivityData={data?.Mixrs}
              objectId={objectId}
              duration={selectedDuration}
              loading={loading}
            />
          ) : scope === 'engagements' ? (
            <EngagementActivity
              type={type}
              engagementActivityData={data?.Engagements}
              objectId={objectId}
              duration={selectedDuration}
              loading={loading}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default Activity
